import {SvgIconProps} from "@mui/material";
import React, {ReactNode} from "react";
import AbstractIcon from "../AbstractIcon";


class ActiveResourcePriority extends AbstractIcon {

    public renderDraw(props: SvgIconProps): ReactNode {
        return (
            <g>
                <path d="m 4,5 v 5 H 5 V 5 Z"/>
                <path d="M 6,6 V 9 H 7 V 6 Z"/>
                <path d="m 8,3 v 9 H 9 V 3 Z"/>
                <path d="m 10,4 v 7 h 1 V 4 Z"/>
                <path d="m 12,2 v 11 h 1 V 2 Z"/>
                <path d="m 14,5 v 5 h 1 V 5 Z"/>
                <path d="m 16,6 v 3 h 1 V 6 Z"/>
                <path d="m 18,4 v 7 h 1 V 4 Z"/>
                <path d="M 2,6 V 9 H 3 V 6 Z"/>
                <path d="m 20,6 v 3 h 1 V 6 Z"/>
                <path d="m 22,7 v 1 h 1 V 7 Z"/>
                <path d="m 12.901833,21.985664 c -0.06644,-0.03274 -0.107057,-0.09207 -0.127128,-0.185639 -0.01075,-0.05016 -0.01472,-0.385902 -0.01175,-0.984259 0.0041,-0.810658 0.0073,-0.91309 0.03005,-0.954364 0.03305,-0.0599 0.08676,-0.109349 0.141158,-0.129962 0.03037,-0.0115 1.438215,-0.01643 4.69696,-0.01643 3.895476,0 4.661775,0.0035 4.703889,0.02103 0.06535,0.0273 0.12863,0.103505 0.149099,0.179536 0.01075,0.04017 0.01488,0.372472 0.012,0.990623 l -0.0043,0.930167 -0.041,0.06195 c -0.02256,0.03407 -0.06521,0.07342 -0.0948,0.08748 -0.0497,0.02359 -0.408646,0.0255 -4.72866,0.02519 -4.274865,-2.79e-4 -4.679203,-0.0025 -4.725451,-0.02527 z m 0.967538,-2.79851 c 1.3e-5,-0.02213 0.06376,-0.504073 0.206402,-1.560405 0.05494,-0.406863 0.117546,-0.874983 0.139118,-1.04027 0.04005,-0.306861 0.202742,-1.529395 0.255333,-1.91872 0.01603,-0.118675 0.05053,-0.375267 0.07665,-0.570221 0.02614,-0.194956 0.05501,-0.392608 0.06417,-0.439226 0.02895,-0.147269 0.106857,-0.372632 0.178514,-0.516281 0.296873,-0.595246 0.843154,-1.001211 1.492348,-1.109034 0.135654,-0.02252 0.291365,-0.02482 1.347715,-0.01976 1.312131,0.0064 1.252016,0.0022 1.56137,0.105083 0.310864,0.103344 0.583928,0.26836 0.821528,0.496422 0.239305,0.229698 0.409409,0.490144 0.512134,0.784122 0.06167,0.176512 0.08372,0.289832 0.140461,0.721782 0.02616,0.199192 0.06432,0.483533 0.08479,0.631869 0.0647,0.46887 0.127254,0.937101 0.247111,1.849368 0.119933,0.912897 0.324661,2.444419 0.340433,2.546735 l 0.0089,0.0578 h -3.738494 c -2.980529,0 -3.738491,-0.0041 -3.738481,-0.01926 z"/>
            </g>
        );
    }

}


export default ActiveResourcePriority;